<template>
<div class="borderlands">
  <h2>Borderlands</h2>

  <p>Select a button to see currently active Borderlands 2 SHiFT keys.</p>

  <div class="tab">
    <button class="tablinks" v-on:click="filterKeys('pc')" v-bind:class="{ active: activeFilter == 'pc' }">PC / MAC</button>
    <button class="tablinks" v-on:click="filterKeys('xbox')" v-bind:class="{ active: activeFilter == 'xbox' }">XB360 / XBOne</button>
    <button class="tablinks" v-on:click="filterKeys('ps')" v-bind:class="{ active: activeFilter == 'ps' }">PS3 / PS4 / PS Vita</button>
  </div>

  <div v-if="keysRequested == true">
    <table v-if="filteredKeys.length > 0">
      <tr>
        <th>Key</th>
        <th>Expires</th>
      </tr>
      <tr v-for="key in filteredKeys" v-bind:key="key.id">
        <td>{{ key.key }}</td>
        <td>{{ key.expiresAt }}</td>
      </tr>
    </table>
    <p v-else>No active keys detected.</p>
  </div>
  <div v-else>
    <p>Requesting active keys.</p>
    <div class="loader"></div>
  </div>

</div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  data: function() {
    return {
      activeKeys: [],
      filteredKeys: [],
      pcKeys: [],
      xboxKeys: [],
      psKeys: [],
      activeFilter: '',
      keysRequested: false
    }
  },
  created: function() {
    Vue.http.get('https://mighty-reef-20023.herokuapp.com/borderlands')
      .then(response => {
        this.keysRequested = true  ;
        this.activeKeys = response.data.activeKeys;
        var activeKeysLength = this.activeKeys.length;
        if (activeKeysLength > 0) {
          for (var i = 0; i < activeKeysLength; i++) {
            var activeKey = this.activeKeys[i];
            var platform = activeKey.platform;
            if (platform.includes('PC')) {
              this.pcKeys.push(activeKey);
            } else if (platform.includes('XB')) {
              this.xboxKeys.push(activeKey);
            } else if (platform.includes('PS')) {
              this.psKeys.push(activeKey);
            }
          }
          this.filterKeys('pc');
        }
      });
  },
  methods: {
    filterKeys: function(filter) {
      this.activeFilter = filter;
      if (filter == 'pc') {
        this.filteredKeys = this.pcKeys;
      } else if (filter == 'xbox') {
        this.filteredKeys = this.xboxKeys;
      } else if (filter == 'ps') {
        this.filteredKeys = this.psKeys;
      }
    }
  }
}
</script>

<style scoped>
.borderlands {
  overflow: auto;
  height: 100vh;
}

::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

h1,
h2 {
  padding-top: 20px;
  font-weight: normal;
}

.loader {
  margin: auto;
  width: 50%;
  border: 16px solid #f3f3f3;
  /* Light grey */
  border-top: 16px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

table {
  margin: auto;
  border-collapse: collapse;
}

th,
td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

tr:hover {
  background-color: #F5F5F5;
}

.tab {
    overflow: hidden;
    border: 1px solid #e6f5ff;
    display: inline-block;
}

.tab button {
    background-color: #0099ff;
    float: center;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    color: #FFF;
}

.tab button:hover {
    background-color: #33adff;
}

.tab button.active {
    background-color: #007acc;
}
</style>
